export default __webpack_public_path__ + "static/media/node-3.f031d61c.jpg";